export default __webpack_public_path__ + "static/media/peak-logo-bottom-right.b5455c26.png";